import { render, staticRenderFns } from "./claims-tab.vue?vue&type=template&id=4e3d9b96&scoped=true&"
import script from "./claims-tab.vue?vue&type=script&lang=js&"
export * from "./claims-tab.vue?vue&type=script&lang=js&"
import style0 from "./claims-tab.vue?vue&type=style&index=0&id=4e3d9b96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3d9b96",
  null
  
)

export default component.exports